import { render, staticRenderFns } from "./CommercialProductExtraInfoEdit.vue?vue&type=template&id=07e02734&scoped=true&"
import script from "./CommercialProductExtraInfoEdit.vue?vue&type=script&lang=js&"
export * from "./CommercialProductExtraInfoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e02734",
  null
  
)

export default component.exports